import { render } from "./AgencyAdmins.vue?vue&type=template&id=b7e04b3c"
import script from "./AgencyAdmins.vue?vue&type=script&lang=js"
export * from "./AgencyAdmins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__